'use es6';

import { LinkedInTargetingFacets } from 'AdsUI/records/ad-management/LinkedInTargetingRecords';
export default [{
  name: 'INTERESTS',
  children: [{
    networkFacet: LinkedInTargetingFacets.GROUPS
  }, {
    networkFacet: LinkedInTargetingFacets.INTERESTS
  }]
}, {
  name: 'DEMOGRAPHICS',
  children: [{
    name: 'EDUCATION',
    children: [{
      networkFacet: LinkedInTargetingFacets.DEGREES
    }, {
      networkFacet: LinkedInTargetingFacets.FIELDS_OF_STUDY
    }, {
      networkFacet: LinkedInTargetingFacets.SCHOOLS
    }]
  }, {
    networkFacet: LinkedInTargetingFacets.GENDERS
  }, {
    networkFacet: LinkedInTargetingFacets.AGE_RANGES
  }, {
    networkFacet: LinkedInTargetingFacets.BEHAVIORS
  }]
}, {
  name: 'JOB_EXPERIENCE',
  children: [{
    networkFacet: LinkedInTargetingFacets.JOB_FUNCTIONS
  }, {
    networkFacet: LinkedInTargetingFacets.SENIORITIES
  }, {
    name: 'JOB_TITLES',
    children: [{
      networkFacet: LinkedInTargetingFacets.TITLES_ALL
    }, {
      networkFacet: LinkedInTargetingFacets.TITLES
    }, {
      networkFacet: LinkedInTargetingFacets.TITLES_PAST
    }]
  }, {
    networkFacet: LinkedInTargetingFacets.SKILLS
  }, {
    networkFacet: LinkedInTargetingFacets.YEARS_OF_EXPERIENCE_RANGES
  }]
}, {
  name: 'COMPANY',
  children: [{
    name: 'COMPANY_NAMES',
    children: [{
      networkFacet: LinkedInTargetingFacets.EMPLOYERS_ALL
    }, {
      networkFacet: LinkedInTargetingFacets.EMPLOYERS
    }, {
      networkFacet: LinkedInTargetingFacets.EMPLOYERS_PAST
    }]
  }, {
    networkFacet: LinkedInTargetingFacets.FIRST_DEGREE_CONNECTION_COMPANIES
  }, {
    networkFacet: LinkedInTargetingFacets.FOLLOWED_COMPANIES
  }, {
    networkFacet: LinkedInTargetingFacets.INDUSTRIES
  }, {
    networkFacet: LinkedInTargetingFacets.STAFF_COUNT_RANGES
  }, {
    networkFacet: LinkedInTargetingFacets.COMPANY_CATEGORY
  }, {
    networkFacet: LinkedInTargetingFacets.GROWTH_RATE
  }]
}];